import { mobileCutoff } from "./constants.js";
import { getRawClassName, selectorToArray } from "./selectors.js";

let tabLinks: HTMLElement[] = [];
let tabContents: HTMLElement[] = [];
let contentContainers: HTMLElement[] = [];

/** Initializes the tabs. (Moves tab correct container, add events, etc.). */
export default function (): void {
	tabLinks = selectorToArray("tabLinks");
	tabContents = selectorToArray("tabContent");
	contentContainers = selectorToArray("tabContentContainer");

	for (const tabLink of tabLinks) {
		tabLink.addEventListener("mouseover", () => {
			setActiveTab(tabLink.dataset.tabid ?? "");
		});
	}
	const first = tabContents[0];
	if (first) {
		const tabID = first.dataset.tabid;
		if (tabID !== undefined) setActiveTab(tabID);
	}
	handleResponsive();
	window.addEventListener("resize", () => {
		handleResponsive();
	});
}

/** Adjusts tab content position based on page size. */
function handleResponsive() {
	const { innerWidth } = window;

	if (innerWidth > mobileCutoff) {
		moveTabContent();
	} else if (innerWidth < mobileCutoff) {
		moveTabContentBack();
	}
}

/** Moves tab content to the tab content container. (For desktop). */
function moveTabContent(): void {
	for (const contentContainer of contentContainers) {
		tabContents.forEach((item) => {
			contentContainer.append(item);
		});
	}
}

/** Moves tab content back to its original position. (For mobile). */
function moveTabContentBack(): void {
	tabContents.forEach((item) => {
		const id = item.dataset.tabid;
		const parent = document.querySelector(
			`a[data-tabid='${id}']`,
		)?.parentElement;
		if (parent) {
			parent.after(item);
		}
	});
}

/**
 * Sets the active tab.
 *
 * @param tabID The ID of the tab to set as active.
 */
function setActiveTab(tabID: string): void {
	tabContents.forEach((item) => {
		item.classList.toggle(
			getRawClassName("activeTab"),
			item.dataset.tabid === tabID,
		);
	});
}
